<template>
  <div :class="['layout', ('app-layout-wrapper-' + (globalConfig.language || 'en'))]">
    <router-view>
      <template v-slot="{ Component }">
        <!--无网络时注销掉当前页面，网络重新连接后重新渲染-->
        <keep-alive :include="keepAliveList">
          <component v-if="visible" :is="Component" :key="routeKey" />
        </keep-alive>
      </template>
    </router-view>
    <abnormalNoNetwork />
  </div>
</template>

<script>
import { ref, computed, watch, onMounted, provide } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import abnormalNoNetwork from '@/components/AbnormalRemind/abnormalNoNetwork/index.vue';
import { jsBridgePanelRefreshPromise, jsBridgeRefreshTokenFromNativePromise, jsBridgeSubjectInfoPromise, useVueStack, isAppEnv, globalConfig } from 'platform-lib-app';
import { useUser } from '@/store/modules/user';
import { usePermission } from '@/store/modules/permission';
import { getSubjectInfo } from '@/utils/jsbridge/webEntrance';

// Toast

import { Toast } from 'vant';
import 'vant/es/toast/style';

// Dialog
import { Dialog } from 'vant';
import 'vant/es/dialog/style';

// Notify
import { Notify } from 'vant';
import 'vant/es/notify/style';

// ImagePreview
import { ImagePreview } from 'vant';
import 'vant/es/image-preview/style';
export default {
  name: 'Layout',
  components: {
    abnormalNoNetwork,
  },
  setup() {
    const visibleGetSUbjectInfo = ref(false);
    getSubjectInfo().then(res => {
      visibleGetSUbjectInfo.value = true;
    });
    const route = useRoute();
    const router = useRouter();

    const { keepAlives } = useVueStack(router);

    const routeKey = computed(() => {
      // routerViewKey 用来解决嵌套路由情况下，子路由改变导致父路由组件刷新问题
      return route?.meta?.routerViewKey || route.fullPath;
    });
    onMounted(() => {
      // 阿拉伯语兼容
      if (globalConfig?.language === 'ar') {
        document.documentElement.setAttribute('dir', 'rtl');
      }
    });
    const permissionStore = usePermission();
    const isNoNet = computed(() => {
      return permissionStore.showNoNet && visibleGetSUbjectInfo.value;
    });
    const userStore = useUser();
    const visible = computed(() => {
      return !isNoNet.value && window.APP_VISIBLE.value;
    });

    if (isAppEnv) {
      // native切换门店后，刷新主体缓存
      jsBridgePanelRefreshPromise({
        complete: async () => {
          userStore.subjectInfo = await jsBridgeSubjectInfoPromise();
        },
      });
      // 刷新accessToken(Native-->h5)
      jsBridgeRefreshTokenFromNativePromise({
        complete: async (res) => {
          console.warn('jsBridgeRefreshTokenFromNativePromise--->', res);
          if (res.data) {
            userStore.token = res.data;
          }
        },
      });
    }
    provide('AppkeepAliveList', keepAlives);

    return {
      keepAliveList: keepAlives,
      router,
      routeKey,
      visible,
      globalConfig
    };
  },
};
</script>

<style lang="scss" scoped>
@import 'assets/styles/base';

.component-layout {
  background-color: #f5f5f5;
}
</style>
<style>
#app {
  height: 100vh; /* 之前是注掉的，打开解决背景颜色覆盖不全问题，如果需要注掉请联系我 */
  overflow: auto;
  background: #f8f8f8;
}
.van-toast {
  z-index: 10002 !important;
}
:deep(.van-search .van-search__field) {
  background: none !important;
}
.van-toast--loading {
  background-color: transparent !important;
  background-image: url(https://cdn-arch-common-prod.cotticoffee.com/images/toB/loading.gif);
  background-size: 65px 65px;
  background-repeat: no-repeat;
  /* background: center; */
  background-position: center;
}
.van-toast--loading .van-toast__text {
  display: none;
}
.van-toast--loading .van-toast__loading {
  display: none;
}
</style>
